export enum VerticalSpaceSize{
    small,
    normal,
    large
}

export interface IVerticalSpaceProps {
    size?: VerticalSpaceSize;
}
